export default __webpack_public_path__ + "static/media/REFIN_affrescati_LP_CONF_TERRA-40X80.2c5d92c2.jpg";